import styled from 'styled-components'

const VideoViewStyled = styled.div`
  height: var(--video-height);
  max-width: var(--video-width);
`

export default VideoViewStyled
